import seedrandom from "seedrandom"

export const createSeedCourseNumber = (id: string): string => {
  const randomNumber = Number(seedrandom(id)().toFixed(5)) * 100000

  return Number(randomNumber.toString()).toFixed(0).toString()
}
